import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import { removeReadOnlyFields } from '../../utils/fieldNormalizers';

import { Location } from './_types';

const readOnlyFields = [
  'created_at',
  'updated_at',
  'links',
  'payout_schedule',
  'stripe_connected',
  'id',
  'stripe_id',
];

export function normalizeLocation(location): Location {
  return camelcaseKeys(location, { deep: true });
}

export function denormalizeLocation(
  location: Partial<Location>
): Partial<Location> {
  const decamelized = decamelizeKeys(location, { deep: true });
  removeReadOnlyFields(decamelized, readOnlyFields);
  return decamelized;
}
